<template>
    <ContainerContent
        class="mb-8"
        max-class="max-w-sm-floor"
        outer-container
    >
        <v-row>
            <v-col>
                <h1 class="page-title">Create Account</h1>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <client-only>
                    <v-card
                        class="sign-up-panel"
                        flat
                    >
                        <NuxtPage
                            :page-key="$route.path"
                            :pre-pop-values="prePopValues"
                            class="d-flex flex-column pa-0 ma-0"
                        ></NuxtPage>

                        <v-card-text>
                            <div class="d-flex justify-end flex-wrap">
                                <ul class="list-style-none text-subtitle-1 font-weight-bold text-left pl-0 mt-4 mt-md-0">
                                    <li><NuxtLink to="/sign-in">Have an account? Sign in here.</NuxtLink></li>
                                </ul>
                            </div>
                        </v-card-text>
                    </v-card>
                </client-only>
            </v-col>
        </v-row>
    </ContainerContent>
</template>

<script lang="ts" setup>
    import type { UserSignUpRequest } from '~/types';
    import type { LocationQuery } from '#vue-router';
    import ContainerContent from '~/components/ContainerContent/ContainerContent.vue';

    definePageMeta({
        scrollToTop: true,
        pageTransition: true
    });

    const nuxtApp = useNuxtApp();
    const { isLoggedIn } = nuxtApp.$user;

    const router = useRouter();
    const { setQueryParams } = useCreateAccount();
    const prePopValues = ref<Nullable<Partial<UserSignUpRequest>>>(null);

    if (!isLoggedIn.value) {
        const q = setQueryParams();
        const step = q.token && q.email ? '/step-2' : '';

        prePopValues.value = q;

        router.push({
            path: `/create-account${step}`,
            query: q as LocationQuery
        });
    } else {
        // User is SIGNED-IN, redirecting to Account page
        await navigateTo('/account');
    }

    const unWatchRouteQuery = watch(
        () => router.currentRoute.value.query,
        (query) => {
            prePopValues.value = query;
        }
    );

    onBeforeUnmount(() => {
        unWatchRouteQuery()
    });
</script>
